import { defineComponent as r, openBlock as n, createBlock as a, unref as p, mergeProps as m, withCtx as c, createElementVNode as f } from "vue";
import { RevIcon as s } from "@ds/components/Icon";
const w = /* @__PURE__ */ r({
  name: "IconArrowDownLeft",
  __name: "IconArrowDownLeft",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const t = o;
    return (i, e) => (n(), a(p(s), m(t, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        f("path", { d: "M18.894 6.166a.75.75 0 0 0-1.06-1.06L6.386 16.553v-5.26a.75.75 0 0 0-1.5 0v6.571a1.25 1.25 0 0 0 1.25 1.25h6.571a.75.75 0 0 0 0-1.5h-5.26L18.894 6.166" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  w as default
};
